import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useAuth0 } from "@auth0/auth0-react";
import Logo from "./Logo";

export default function Navbar({ onCartOpen }) {
  const [open, setOpen] = useState(false);
  const { cart } = useCart();
  const location = useLocation();
  const { loginWithRedirect, logout, isAuthenticated, user } = useAuth0();

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* NAVBAR */}
      <header className="sticky top-0 z-50">
        <div className="backdrop-blur-xl bg-[#FFF5F8]/85 border-b border-pink-100">
          <div className="w-full px-6 lg:px-14">
            <div className="h-20 flex items-center justify-between">

              {/* LOGO */}
              <Logo />

              {/* ACTIONS */}
              <div className="flex items-center gap-4">

                {/* CART BUTTON (NO NAVIGATION) */}
                <button
                  onClick={onCartOpen}
                  className="relative w-12 h-12 rounded-full bg-white border shadow flex items-center justify-center"
                >
                  <ShoppingBag className="w-5 h-5 text-pink-600" />
                  {cart.length > 0 && (
                    <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-pink-600 text-white text-xs flex items-center justify-center">
                      {cart.length}
                    </span>
                  )}
                </button>

                {/* MENU */}
                <button
                  onClick={() => setOpen(true)}
                  className="w-12 h-12 rounded-full bg-white border shadow flex items-center justify-center"
                >
                  <Menu className="w-5 h-5 text-pink-600" />
                </button>

              </div>
            </div>
          </div>
        </div>
      </header>

      {/* OVERLAY */}
      <AnimatePresence>
        {open && (
          <motion.div
            className="fixed inset-0 bg-black/30 z-40"
            onClick={() => setOpen(false)}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          />
        )}
      </AnimatePresence>

      {/* SIDE MENU */}
      <AnimatePresence>
        {open && (
          <motion.aside
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            className="fixed right-0 top-0 h-full w-80 bg-white z-50 shadow-lg"
          >
            <div className="p-6 space-y-3">
              <NavItem to="/" label="Home" onClick={() => setOpen(false)} />
              <NavItem to="/cart" label="Cart" onClick={() => setOpen(false)} />
              <NavItem to="/wishlist" label="Wishlist" onClick={() => setOpen(false)} />
              <NavItem to="/profile" label="Profile" onClick={() => setOpen(false)} />

              {!isAuthenticated ? (
                <button
                  onClick={() => loginWithRedirect()}
                  className="w-full py-2 bg-pink-500 text-white rounded"
                >
                  Login
                </button>
              ) : (
                <button
                  onClick={() =>
                    logout({ logoutParams: { returnTo: window.location.origin } })
                  }
                  className="w-full py-2 bg-red-500 text-white rounded"
                >
                  Logout
                </button>
              )}
            </div>
          </motion.aside>
        )}
      </AnimatePresence>
    </>
  );
}

function NavItem({ to, label, onClick }) {
  return (
    <Link
      to={to}
      onClick={onClick}
      className="block px-4 py-2 rounded hover:bg-pink-100"
    >
      {label}
    </Link>
  );
}
